import { getMindCondition } from "controllers/MindCondition";
import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";


async function dataStream(callback) {
  const mindCondition=await getMindCondition();
  callback(sortArrayPipe.transform(mindCondition, 'value'));
}
const MintConditionSelect = withBaseSelect([], dataStream);
export default MintConditionSelect;
